<template>
    <div class="gallery grid grid__base"
            :class="rootClasses">
        <div class="gallery--container grid--container u-iknowwhatimdoing">
            <div class="gallery--wrapper-row grid--row">
                <div class="gallery--wrapper grid--col">
                    <div class="gallery--swiper-container swiper-container"
                            ref="slider">
                        <div class="gallery--swiper-wrapper swiper-wrapper">
                            <div class="gallery--slide swiper-slide"
                                    v-for="(item, idx) in items"
                                    :class="slideClass"
                                    :key="idx">
                                <div class="gallery--slide-content">
                                    <picture-element class="gallery--image"
                                            v-bind="item"/>
                                </div>
                            </div>
                        </div>

                        <button class="gallery--btn gallery--btn-prev"
                                v-if="items.length > 1"
                                :class="btnPrevClass">
                            <base-icon symbol="chevron-left"
                                    size="small"/>
                        </button>
                        <button class="gallery--btn gallery--btn-next   "
                                v-if="items.length > 1"
                                :class="btnNextClass"
                        >
                            <base-icon symbol="chevron-right"
                                    size="small"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';

    import bemMixin from 'framework/mixins/bem';
    import Swiper from 'swiper';

    export default {
        components: { PictureElement },
        mixins: [bemMixin('gallery')],
        props: {
            /** @type {ISvgImageSet[]} */
            items: {
                type: Array,
                default: () => [],
            },
        },

        data() {
            return {
                swiper: null,
            };
        },

        computed: {
            rootClasses() {
                return [
                    ...this.bemFacets,
                    this.bemAdd(this.items.length === 1 ? 'full-width' : null),
                ];
            },

            slideClass() {
                return [
                    this.bemAdd(this.items.length === 1 ? 'active' : null, 'slide'),
                ];
            },

            isBeginning() {
                if (!this.swiper) {
                    return false;
                }

                return this.swiper.isBeginning;
            },

            isEnd() {
                if (!this.swiper) {
                    return false;
                }

                return this.swiper.isEnd;
            },

            btnPrevClass() {
                return this.bemAdd(this.isBeginning ? 'disabled' : null, 'btn');
            },

            btnNextClass() {
                return this.bemAdd(this.isEnd ? 'disabled' : null, 'btn');
            },
        },

        mounted() {
            if (this.items.length > 1) {
                this.swiper = new Swiper(this.$refs.slider, {
                    allowTouchMove: true,
                    speed: 200,
                    spaceBetween: 100,
                    slidesPerView: 1,
                    slideActiveClass: 'gallery--slide__active',
                    navigation: {
                        nextEl: '.gallery--btn-next',
                        prevEl: '.gallery--btn-prev',
                    },
                });
            }
        },

    };
</script>
